export class EmployeeDetailViewModel {
    constructor() {
        this.firstName = " ";
        this.lastName = " ";
        this.emailId = " ";
        this.workPlace = "";
        this.skills = "";
        this.phoneNo = null;
        this.dateOfBirth = null;
        this.profileImageURL = "";
        this.dateOfBirthAsString = "";
        this.dateOfJoinAsString = "";
        this.reportingTo = null;
        this.designationId = null;
        this.reportingToUserName = "";
        this.designation = "";
        this.startTimeAsString = "";
        this.endTimeAsString = "";
        this.isDeactivate = false;
    }
}
export default class EmployeeDetailView extends EmployeeDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
